module.exports = __webpack_public_path__ + "static/media/sort-size-down.454f9753.svg";